"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _colors = require("@mui/material/colors");
var _formik = require("formik");
var _notistack = require("notistack");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var Yup = _interopRequireWildcard(require("yup"));
var _environment = require("../../environment");
var _services = require("../../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SignUpForm({
  widgetConfig,
  onRegistered,
  ...props
}) {
  const {
    i18n: {
      language
    },
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    isSubmitting,
    values,
    touched,
    errors,
    handleChange,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      email: '',
      password: '',
      passwordConfirmation: '',
      approveGCU: false
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required(t('commons.sign_in_form.email_required') || ''),
      password: Yup.string().required(t('commons.sign_up_form.password_pattern') || '').matches(/^(?=.*[\d])(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/g, t('commons.sign_up_form.password_pattern') || ''),
      passwordConfirmation: Yup.string().when('password', {
        is: password => password,
        then: shema => shema.oneOf([Yup.ref('password')], t('commons.sign_up_form.passwords_must_match') || '').required(t('commons.sign_up_form.passwords_must_match') || '')
      }),
      approveGCU: Yup.boolean().oneOf([true])
    }),
    enableReinitialize: true,
    onSubmit
  });
  async function onSubmit({
    email,
    password
  }, {
    setSubmitting,
    setErrors
  }) {
    setSubmitting(true);
    try {
      const user = await _services.AuthService.register(email, password, language);
      onRegistered(user);
    } catch (err) {
      if (err && typeof err === 'object' && err.code === 409) {
        setErrors({
          email: t('commons.sign_up_form.email_already_exists') || ''
        });
      } else {
        enqueueSnackbar(t('commons.sign_up_form.server_error'));
      }
      setSubmitting(false);
    }
  }
  return /*#__PURE__*/_react.default.createElement(StyledForm, _extends({
    onSubmit: handleSubmit
  }, props), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    disabled: isSubmitting,
    error: Boolean(errors.email && touched.email),
    helperText: touched.email && errors.email,
    id: "email",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_in_form.email"
    }),
    margin: "dense",
    name: "email",
    onChange: handleChange,
    size: "small",
    type: "email",
    value: values.email,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    autoComplete: "new-password",
    disabled: isSubmitting,
    error: Boolean(errors.password && touched.password),
    helperText: touched.password && errors.password || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_up_form.password_pattern"
    }),
    id: "password",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_in_form.password"
    }),
    margin: "dense",
    name: "password",
    onChange: handleChange,
    size: "small",
    type: "password",
    value: values.password,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    autoComplete: "new-password",
    disabled: isSubmitting,
    error: Boolean(errors.passwordConfirmation && touched.passwordConfirmation),
    helperText: touched.passwordConfirmation && errors.passwordConfirmation,
    id: "passwordConfirmation",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_up_form.password_confirmation"
    }),
    margin: "dense",
    name: "passwordConfirmation",
    onChange: handleChange,
    size: "small",
    type: "password",
    value: values.passwordConfirmation,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    component: "fieldset",
    disabled: isSubmitting,
    margin: "dense"
  }, /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      color: "primary",
      name: "approveGCU",
      onChange: handleChange,
      style: errors.approveGCU && touched.approveGCU ? {
        color: _colors.red[500]
      } : {},
      value: values.approveGCU
    }),
    label: /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "caption"
    }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      components: [/*#__PURE__*/_react.default.createElement(_Typography2.default, {
        color: "primary",
        component: "a",
        href: `${_environment.prodFrontendUrl}/fr/eula/`,
        key: 0,
        variant: "caption"
      }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
        color: "primary",
        component: "a",
        href: `${_environment.prodFrontendUrl}/fr/privacy-policy/`,
        key: 0,
        variant: "caption"
      })],
      i18nKey: "commons.sign_up_form.accept_gcu_and_privacy_policy"
    }))
  })), widgetConfig?.code === 'lav' && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    sx: {
      marginTop: '8px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement(_Typography2.default, {
      color: "primary",
      component: "a",
      href: "https://www.loireavelo.fr/inscription-newsletter/",
      key: 0,
      target: "_blank",
      variant: "caption"
    })],
    i18nKey: "commons.sign_up_form.share_data_with_lav"
  }))), /*#__PURE__*/_react.default.createElement(StyledButton, {
    color: "primary",
    disabled: isSubmitting,
    size: "medium",
    type: "submit",
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.sign_up"
  })));
}
const StyledForm = _styledComponents.styled.form`
  display: flex;
  flex-direction: column;
`;
const StyledFormControlLabel = (0, _styledComponents.styled)(_FormControlLabel2.default)`
  && {
    span {
      line-height: 1.1;
    }
  }
`;
const StyledButton = (0, _styledComponents.styled)(_Button2.default)`
  && {
    margin-top: 8px;
  }
`;
var _default = exports.default = SignUpForm;